module.exports = __webpack_public_path__ + "assets/1bfae88596709a64c05c94e8bd3b75df.mp3";